import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { GtmStatsDataEntityInterface } from '../data/entity.interface';
import { GtmStatsDataEcommerceCheckoutInterface } from '../data/ecommerce-checkout.interface';
import { GtmStatsDataPropertyInterface } from '../data/property.interface';

export class GtmStatsAdapterEcommerceCheckout implements StatsAdapterInterface {
  /**
   *
   * @param entity
   * @param context
   */
  constructor(protected entity: GtmStatsDataEntityInterface, protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): GtmStatsDataEcommerceCheckoutInterface {
    if (!this.context.global.currency) {
      throw new Error('Stats global context "currency" is not set.');
    }

    let step = 0;

    // Lead email
    if (this.context.local.lead && this.context.local.lead.medium === 'email') {
      step = 6;
      // Lead call back
    } else if (this.context.local.lead && this.context.local.lead.medium === 'call_back') {
      step = 8;
      // Property page, agent page, broker page
    } else if (this.context.global.property_page || this.context.global.agent_page || this.context.global.broker_page) {
      step = 1;
    }

    // Property metric2 is set
    if ((<GtmStatsDataPropertyInterface>this.entity).metric2 === '1') {
      step = 2;
    }

    return {
      ecommerce: {
        checkout: {
          actionField: {
            action: 'checkout',
            step: String(step),
            list: this.entity.list,
          },
          products: [this.entity],
        },
        currencyCode: this.context.global.currency,
      },
      event: 'checkout',
    };
  }
}
